/* ============================================================
   Hanger Uniforms — Design Studio
   Self-contained, dependency-free product customizer.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Print-area rectangles (% of stage: x,y,w,h) ---------- */
  var PRINT_AREAS = {
    'front': { view: 'front', rect: [34, 30, 32, 34] },
    'back':  { view: 'back',  rect: [33, 26, 34, 40] }
  };
  // Category-specific default print boxes (used when no calibrated 'Garment
  // photo' block matches). Categories not listed use PRINT_AREAS above.
  var DEFAULT_RECTS = {
    hat: { front: [36, 30, 28, 18], back: [36, 34, 28, 16] },
    bag: { front: [28, 30, 44, 42], back: [28, 30, 44, 42] }
  };
  var ALL_LOCATIONS = [
    { id: 'front', label: 'Front Center' },
    { id: 'back', label: 'Full Back' }
  ];

  function init(root) {
    var stage = root.querySelector('[data-stage]');
    var garmentImg = root.querySelector('[data-garment-img]');
    var printArea = root.querySelector('[data-printarea]');
    var tabsWrap = root.querySelector('[data-tabs]');
    var colorsWrap = root.querySelector('[data-colors]');
    var colorName = root.querySelector('[data-color-name]');
    var fileInput = root.querySelector('[data-file]');
    var textBar = root.querySelector('[data-textbar]');
    var textInput = root.querySelector('[data-text-input]');
    var fontSelect = root.querySelector('[data-font]');
    var textColor = root.querySelector('[data-text-color]');
    var sizesWrap = root.querySelector('[data-sizes]');
    var methodChecks = root.querySelectorAll('[data-method-check]');
    var screenColorsWrap = root.querySelector('[data-screen-colors-wrap]');
    var screenColorsInput = root.querySelector('[data-screen-colors]');
    var toast = root.querySelector('[data-toast]');
    var categoriesWrap = root.querySelector('[data-categories]');
    var blanksWrap = root.querySelector('[data-blanks]');
    var chosenBlankWrap = root.querySelector('[data-chosen-blank]');
    var chosenBlankGroup = root.querySelector('[data-chosen-blank-group]');
    var blanksGroup = root.querySelector('[data-blanks-group]');
    var changeBlankBtns = root.querySelectorAll('[data-change-blank]');
    // 3-step wizard (generic Design Studio only — product-page embeds never
    // get data-wizard and keep their original single-screen layout, per
    // ux.md §6: forcing a "choose your blank" screen on a customer who
    // already landed on a specific product page would be redundant).
    var IS_WIZARD = root.hasAttribute('data-wizard');
    var stepsWrap = root.querySelector('[data-steps]');
    var stepsFill = root.querySelector('[data-steps-fill]');
    var orderForm = root.querySelector('[data-order-form]');
    // Up to 3 independently-optional file inputs (properties[Artwork File 1/2/3])
    // rather than one <input multiple> — Shopify line-item properties are
    // single key/value pairs, so a single file input can only ever persist
    // one file as one CDN link on the order; multiple files chosen via one
    // `multiple` input would all compete for that same property key and only
    // one (if any) would reliably survive to the order. Separate property
    // names guarantee each file becomes its own clickable CDN link in Admin.
    var artworkFileInputs = root.querySelectorAll('[data-artwork-file]');
    var artworkFilenameEl = root.querySelector('[data-artwork-filename]');

    var COLORS = JSON.parse(root.getAttribute('data-colors-json') || '[]');
    var GARMENTS = JSON.parse(root.getAttribute('data-garments-json') || '[]');
    var BLANKS = JSON.parse(root.getAttribute('data-blanks-json') || '{}');
    var PRICES = JSON.parse(root.getAttribute('data-prices-json') || '{}');
    var variantId = root.getAttribute('data-variant-id') || '';
    var quoteUrl = root.getAttribute('data-quote-url') || '/pages/request-a-quote';
    var MIN_QTY = parseInt(root.getAttribute('data-min-qty'), 10) || 12;
    // Product mode: use the real product photo(s) as the base instead of SVG garments
    var PRODUCT_IMAGE = root.getAttribute('data-product-image') || '';
    var PRODUCT_BACK = root.getAttribute('data-product-back-image') || '';
    // Set when a 'Garment photo' block's match_tags matched this product —
    // its calibrated print boxes replace the fixed default rects below.
    var PRODUCT_AREAS = null;
    try { PRODUCT_AREAS = JSON.parse(root.getAttribute('data-product-areas') || 'null'); } catch (e) { PRODUCT_AREAS = null; }
    // IS_PRODUCT means "this section is embedded directly on a real product page".
    // It must NOT be derived from colour photos — the general studio (this page)
    // now supports per-colour photos too, and needs its own branch below.
    var IS_PRODUCT = !!PRODUCT_IMAGE;

    // When set (dedicated per-category pages: Tote Bags, T-Shirts, Hoodies,
    // etc.), the studio never shows category tabs — it's a single-purpose
    // page. Most lock to exactly one product-tag category, but the T-Shirt
    // studio locks to a *group* (tee,longsleeve,tank,polo — comma-separated)
    // since those four sub-categories all route to that one page.
    var LOCKED_CATEGORIES = (root.getAttribute('data-locked-category') || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var LOCKED_CATEGORY = LOCKED_CATEGORIES.length === 1 ? LOCKED_CATEGORIES[0] : '';

    var LOCATIONS = ALL_LOCATIONS;
    // Once a blank is chosen, the "Choose Your Blank" grid is hidden in favor
    // of the compact "Product" tag — set true to bring the grid back (via the
    // "Change" link) so the customer can pick a different one.
    var showBlankPicker = false;
    // Product-page embeds start locked to that one real product (PRODUCT_IMAGE/
    // PRODUCT_AREAS). Once the customer picks a different category or a
    // different blank from the "Design a different product" picker, this
    // flips false and the canvas switches over to the normal blank-driven
    // photo/print-area logic — same as the general multi-category studio.
    var usingProductDefault = IS_PRODUCT;

    var state = {
      step: 'blank',    // wizard only: 'blank' | 'customize' | 'submit'
      color: COLORS[0] ? COLORS[0].hex : '#1f2937',
      colorLabel: COLORS[0] ? COLORS[0].name : 'Black',
      colorImage: COLORS[0] ? (COLORS[0].image || '') : '',
      colorBack: COLORS[0] ? (COLORS[0].back || '') : '',
      location: 'front',
      designs: {},          // location -> [elements]
      selected: null,
      counter: 0,
      // Single-screen studio (generic studio only): category + canvas + blank
      // picker + color + order panel all shown together, no steps. The
      // canvas always shows the actual selected blank's real product photo
      // (and that photo's own colourway once a color is picked) — `category`
      // only filters which real products appear in the blank picker.
      category: '',
      blank: null,       // chosen product handle
      blankLabel: '',
      blankCategory: '',
      blankImage: '',
      blankColorsOverride: null, // set for preset products missing from BLANKS (see fetchPresetColors)
      product: null      // wizard only: the catalog product chosen in Step 1 (see chooseProduct)
    };
    LOCATIONS.forEach(function (l) { state.designs[l.id] = []; });

    // Preset arrivals for a product outside the tag-scanned catalog have no
    // BLANKS entry to source real colourway photos from — fetchPresetColors
    // pulls them directly from the product's own JSON so the color swatches
    // still show that product's actual variants, not the generic palette.
    var presetNeedsColorFetch = false;
    var presetHandle = null;
    // True only when arriving via a product page's "Customize in the Design
    // Studio" link (blank_handle in the URL) — that customer already chose
    // their product, so the blank picker stays hidden (don't recommend
    // something else). Arriving from a generic "Start Designing" entry (no
    // preset) is a browsing flow — the blank picker must stay visible there
    // so the customer can see and pick from the different product blanks.
    var arrivedViaPreset = false;

    (function readPreset() {
      var params = new URLSearchParams(window.location.search);
      var handle = params.get('blank_handle');
      if (!handle || IS_PRODUCT || IS_WIZARD) return;
      arrivedViaPreset = true;
      state.blankCategory = params.get('blank_category') || 'tee';
      state.category = state.blankCategory;
      state.blank = handle;
      state.blankLabel = params.get('blank_label') || handle;
      // Prefer the product's own photo passed directly in the URL (always
      // correct, from the product page itself) over looking it up in the
      // auto-scanned catalog — that lookup silently comes up empty for any
      // product missing one of the exact category tags, which used to leave
      // the canvas showing a generic placeholder instead of a real photo.
      var urlImage = params.get('blank_image');
      if (urlImage) {
        state.blankImage = urlImage;
      }
      var match = (BLANKS[state.blankCategory] || []).filter(function (b) { return b.handle === handle; })[0];
      if (match) {
        state.blankLabel = match.label;
        if (!urlImage) state.blankImage = match.image;
      } else {
        presetNeedsColorFetch = true;
        presetHandle = handle;
      }
    })();

    // Substring match against a broad apparel-color vocabulary, ordered
    // most-specific-first, mirroring the Liquid resolver in
    // sections/design-studio.liquid so real vendor color names (e.g.
    // "Ash Black", "Space Grey", "Vintage Dusty Blue", "Greige") resolve
    // to a real hex instead of collapsing into one generic fallback gray.
    var COLOR_HEX_CHAIN = [
      ['cream', '#ede4d3'], ['ivory', '#ede4d3'], ['natural', '#ede4d3'],
      ['white', '#f5f5f5'],
      ['black', '#1a1a1a'],
      ['navy', '#1f2a44'],
      ['dusty blue', '#7392b7'],
      ['sky blue', '#7ec4e8'],
      ['teal', '#2c7a7b'],
      ['turquoise', '#30bfbf'],
      ['royal', '#2f57b8'], ['blue', '#2f57b8'],
      ['burgundy', '#6d1f2b'], ['wine', '#6d1f2b'], ['cranberry', '#6d1f2b'],
      ['maroon', '#6a2231'],
      ['brick', '#a44a34'], ['rust', '#a44a34'],
      ['red', '#c0392b'], ['cardinal', '#c0392b'], ['cherry', '#c0392b'],
      ['charcoal', '#3a3d42'],
      ['grey', '#8a8d91'], ['gray', '#8a8d91'], ['stone', '#8a8d91'], ['space', '#8a8d91'],
      ['camel', '#c19a6b'], ['tan', '#c19a6b'], ['khaki', '#c19a6b'], ['sand', '#c19a6b'], ['latte', '#c19a6b'], ['oatmeal', '#c19a6b'], ['greige', '#c19a6b'],
      ['bone', '#e8e0d0'],
      ['forest', '#2e5d3b'], ['hunter', '#2e5d3b'],
      ['olive', '#6b6b3a'],
      ['laurel', '#7a8b6f'], ['sage', '#7a8b6f'],
      ['mint', '#9fd8c4'],
      ['kelly', '#2e7d4f'], ['green', '#2e7d4f'],
      ['purple', '#5b3a8e'], ['lavender', '#5b3a8e'],
      ['coral', '#f08a6c'],
      ['orange', '#f26a21'],
      ['mustard', '#c9a227'], ['gold', '#c9a227'],
      ['yellow', '#f2c94c'],
      ['pink', '#eab8c4'],
      ['chocolate', '#5a3d2b'], ['coffee', '#5a3d2b'], ['mocha', '#5a3d2b'], ['brown', '#5a3d2b'],
      ['silver', '#b8babd'],
      ['heather', '#9aa0a6']
    ];
    function resolveColorHex(name) {
      var n = (name || '').toLowerCase();
      for (var i = 0; i < COLOR_HEX_CHAIN.length; i++) {
        if (n.indexOf(COLOR_HEX_CHAIN[i][0]) !== -1) return COLOR_HEX_CHAIN[i][1];
      }
      return '#6b7280';
    }
    function fetchPresetColors(handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || state.blank !== handle) return;
          // /products/{handle}.js returns options as {name, position, values}
          // objects, not plain strings — pull the name out of each.
          var colorIdx = -1;
          (p.options || []).forEach(function (opt, i) {
            var n = ((opt && opt.name) || '').toLowerCase();
            if (colorIdx === -1 && (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1)) colorIdx = i;
          });
          if (colorIdx === -1) return;
          var key = 'option' + (colorIdx + 1);
          var seen = {}, colors = [];
          (p.variants || []).forEach(function (v) {
            var name = v[key];
            if (!name || seen[name]) return;
            seen[name] = true;
            var img = (v.featured_image && v.featured_image.src) || (p.featured_image && p.featured_image.src) || state.blankImage;
            if (img && img.indexOf('width=') === -1) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=900';
            colors.push({ name: name, hex: resolveColorHex(name), photo: img });
          });
          if (!colors.length) return;
          state.blankColorsOverride = colors;
          resetColorForGarment();
          buildColors();
          toggleColorGroup();
          renderGarment();
          updateSummary();
        })
        .catch(function () {});
    }

    /* ----- rendering ----- */
    // Optional merchant-calibrated print-area block for a category
    function garmentBlockFor(cat) {
      return GARMENTS.filter(function (g) { return g.category === cat; })[0] || null;
    }
    function currentGarment() { return GARMENTS.filter(function (g) { return g.category === state.category; })[0] || GARMENTS[0]; }
    function baseImageFor(view) {
      // Wizard: the chosen catalog product's own photos only. Front = the
      // selected colour's image; Back = the product's second photo when it
      // has one, else the same front photo.
      if (state.product) {
        var front = state.colorImage || state.product.images[0] || '';
        if (view === 'back') return state.product.images[1] || front;
        return front;
      }
      if (IS_PRODUCT && usingProductDefault) {
        if (view === 'back') return state.colorBack || PRODUCT_BACK || state.colorImage || PRODUCT_IMAGE;
        return state.colorImage || PRODUCT_IMAGE;
      }
      // General studio priority for the Back view: 1) the selected colour
      // variant's own back photo, 2) the chosen blank's product-level back
      // photo (its second real photo, if the vendor supplied one), 3) the
      // front photo/colour image as a last resort so Back never renders
      // blank just because no distinct back shot exists for this blank.
      var blankBack = '';
      var b = currentBlank();
      if (b && b.back) blankBack = b.back;
      if (view === 'back') {
        return state.colorBack || blankBack || state.colorImage || state.blankImage || '';
      }
      // General studio priority: 1) the selected colour variant's own real
      // photo, 2) the chosen blank's default product photo, 3) fall through
      // to the tinted SVG. The canvas always reflects the actual product the
      // customer picked — never a generic stock photo.
      if (state.colorImage) return state.colorImage;
      if (state.blankImage) return state.blankImage;
      return '';
    }
    function renderGarment() {
      var view = PRINT_AREAS[state.location].view;
      var src = baseImageFor(view);
      if (src) {
        // Show the real photo as-is — never paint a flat color-tint overlay
        // over it (many products share one photo across colours). No SVG or
        // stock fallback exists: with no photo the stage simply stays empty.
        var img = document.createElement('img');
        img.className = 'studio__base-img';
        img.alt = (state.product ? state.product.title + ' — ' : '') + state.colorLabel;
        img.decoding = 'async';
        img.addEventListener('load', function () { img.classList.add('is-loaded'); });
        img.src = src;
        garmentImg.innerHTML = '';
        garmentImg.appendChild(img);
        if (img.complete) img.classList.add('is-loaded');
      } else {
        garmentImg.innerHTML = '';
      }
    }
    // Print-area rect for a location — a garment photo can override front/back
    function areaFor(loc) {
      var pa = PRINT_AREAS[loc];
      if (IS_PRODUCT && usingProductDefault) {
        if (PRODUCT_AREAS) {
          var a2 = PRODUCT_AREAS[loc] || (pa.view === 'back' ? PRODUCT_AREAS.back : PRODUCT_AREAS.front);
          if (a2 && a2.length === 4) return a2;
        }
      } else {
        var g = state.product ? garmentBlockFor(state.blankCategory) : currentGarment();
        if (g && g.areas) {
          // Look up this exact location first, falling back to the shared
          // front/back box if it wasn't set.
          var a = g.areas[loc] || (pa.view === 'back' ? g.areas.back : g.areas.front);
          if (a && a.length === 4) return a;
        }
      }
      var def = DEFAULT_RECTS[state.product ? state.blankCategory : ''];
      return (def && def[loc]) || pa.rect;
    }
    function renderPrintArea() {
      var r = areaFor(state.location);
      printArea.style.left = r[0] + '%';
      printArea.style.top = r[1] + '%';
      printArea.style.width = r[2] + '%';
      printArea.style.height = r[3] + '%';
    }
    function renderElements() {
      // remove existing element nodes
      Array.prototype.slice.call(stage.querySelectorAll('[data-el]')).forEach(function (n) { n.remove(); });
      (state.designs[state.location] || []).forEach(function (el) {
        stage.appendChild(buildEl(el));
      });
      updateSummary();
    }
    function buildEl(el) {
      var node = document.createElement('div');
      node.className = 'studio__el' + (state.selected === el.id ? ' is-selected' : '');
      node.setAttribute('data-el', el.id);
      node.style.left = el.x + '%';
      node.style.top = el.y + '%';
      node.style.width = el.w + '%';
      node.style.height = el.h + '%';
      node.style.transform = 'rotate(' + el.rot + 'deg)';
      if (el.type === 'image') {
        node.innerHTML = '<img src="' + el.src + '" alt="artwork">';
      } else {
        node.innerHTML = '<span class="studio__el-text" style="color:' + el.color + ';font-family:' + el.font + ';font-size:' + el.size + 'px;">' + escapeHtml(el.text) + '</span>';
        node.style.height = 'auto';
      }
      node.insertAdjacentHTML('beforeend',
        '<span class="studio__handle studio__handle--rotate" data-h="rotate" aria-hidden="true" title="Rotate">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3.2-6.9"/><polyline points="21 3 21 9 15 9"/></svg>' +
        '</span>' +
        '<span class="studio__handle studio__handle--resize" data-h="resize" aria-hidden="true" title="Resize">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>' +
        '</span>' +
        '<span class="studio__handle studio__handle--delete" data-h="delete" aria-hidden="true" title="Delete">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="6" y1="18" x2="18" y2="6"/></svg>' +
        '</span>');
      attachInteract(node, el);
      return node;
    }

    /* ----- selection -----
       Toggle the .is-selected class in place instead of rebuilding every node.
       Rebuilding on pointerdown detached the node being dragged (stale ref) and
       repainted every image — the main source of drag jank. */
    function markSelected() {
      Array.prototype.forEach.call(stage.querySelectorAll('[data-el]'), function (n) {
        n.classList.toggle('is-selected', n.getAttribute('data-el') === String(state.selected));
      });
    }
    function select(id) { state.selected = id; markSelected(); syncTextBar(); }
    function deselect() { if (state.selected) { state.selected = null; markSelected(); textBar.classList.remove('is-open'); } }

    /* ----- interactions (drag / resize / rotate) ----- */
    function attachInteract(node, el) {
      node.addEventListener('pointerdown', function (e) {
        if (e.target.getAttribute('data-h')) return;
        e.preventDefault();
        if (node.setPointerCapture) { try { node.setPointerCapture(e.pointerId); } catch (err) {} }
        select(el.id);
        var rect = stage.getBoundingClientRect();
        var startX = e.clientX, startY = e.clientY, dx = 0, dy = 0;
        node.style.willChange = 'transform';
        // Move with GPU-composited transform (no layout/repaint of the bitmap)…
        function move(ev) {
          dx = ev.clientX - startX; dy = ev.clientY - startY;
          node.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) rotate(' + el.rot + 'deg)';
        }
        // …then bake the final position into left/top on release.
        function end() {
          el.x = clamp(el.x + dx / rect.width * 100, -5, 95);
          el.y = clamp(el.y + dy / rect.height * 100, -5, 95);
          node.style.left = el.x + '%'; node.style.top = el.y + '%';
          node.style.transform = 'rotate(' + el.rot + 'deg)';
          node.style.willChange = '';
        }
        rafDrag(move, end);
      });
      var rz = node.querySelector('[data-h="resize"]');
      rz.addEventListener('pointerdown', function (e) {
        e.preventDefault(); e.stopPropagation(); select(el.id);
        var rect = stage.getBoundingClientRect();
        var startX = e.clientX, ow = el.w, oh = el.h, ratio = el.h / el.w;
        function move(ev) {
          var dw = (ev.clientX - startX) / rect.width * 100;
          el.w = clamp(ow + dw, 5, 90);
          if (el.type === 'image') { el.h = el.w * ratio; node.style.height = el.h + '%'; }
          else { el.size = Math.max(8, el.size * (el.w / ow)); node.querySelector('.studio__el-text').style.fontSize = el.size + 'px'; ow = el.w; }
          node.style.width = el.w + '%';
        }
        rafDrag(move, updateSummary);
      });
      var rot = node.querySelector('[data-h="rotate"]');
      rot.addEventListener('pointerdown', function (e) {
        e.preventDefault(); e.stopPropagation(); select(el.id);
        var box = node.getBoundingClientRect();
        var cx = box.left + box.width / 2, cy = box.top + box.height / 2;
        function move(ev) {
          el.rot = Math.round(Math.atan2(ev.clientY - cy, ev.clientX - cx) * 180 / Math.PI + 90);
          node.style.transform = 'rotate(' + el.rot + 'deg)';
        }
        rafDrag(move);
      });
      node.querySelector('[data-h="delete"]').addEventListener('pointerdown', function (e) {
        e.preventDefault(); e.stopPropagation();
        var arr = state.designs[state.location];
        arr.splice(arr.indexOf(el), 1);
        state.selected = null; renderElements(); textBar.classList.remove('is-open');
      });
    }
    /* ----- add elements ----- */
    function addImage(src) {
      var id = ++state.counter;
      var r = areaFor(state.location);
      var el = { id: id, type: 'image', src: src, x: r[0] + r[2] * 0.15, y: r[1] + r[3] * 0.15, w: r[2] * 0.7, h: r[3] * 0.7, rot: 0 };
      state.designs[state.location].push(el);
      renderElements();   // draw the new node (select() alone no longer rebuilds)
      select(id);
    }
    function addText() {
      var id = ++state.counter;
      var r = areaFor(state.location);
      state.designs[state.location].push({ id: id, type: 'text', text: 'Your Text', x: r[0] + 2, y: r[1] + r[3] / 2, w: r[2] - 4, h: 10, rot: 0, color: '#111111', font: 'Poppins, sans-serif', size: 22 });
      renderElements();   // draw the new node (select() alone no longer rebuilds)
      select(id);
      textBar.classList.add('is-open');
      textInput.value = 'Your Text'; textInput.focus(); textInput.select();
    }
    function syncTextBar() {
      var el = current();
      if (el && el.type === 'text') {
        textBar.classList.add('is-open');
        textInput.value = el.text; fontSelect.value = el.font; textColor.value = el.color;
      } else { textBar.classList.remove('is-open'); }
    }
    function current() {
      return (state.designs[state.location] || []).filter(function (e) { return e.id === state.selected; })[0];
    }
    /* ----- tabs / colors / garments ----- */
    function buildTabs() {
      tabsWrap.innerHTML = '';
      LOCATIONS.forEach(function (l) {
        var b = document.createElement('button');
        b.type = 'button';
        var active = l.id === state.location;
        b.className = 'studio__tab' + (active ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        b.innerHTML = l.label + (state.designs[l.id].length ? '<span class="dot"></span>' : '');
        b.addEventListener('click', function () { state.location = l.id; state.selected = null; buildTabs(); renderGarment(); renderPrintArea(); renderElements(); textBar.classList.remove('is-open'); });
        tabsWrap.appendChild(b);
      });
    }
    // Once a real blank is chosen, its own Color option drives the swatch
    // list; before that, fall back to the shared curated palette. Preset
    // products missing from BLANKS get their colors fetched directly (see
    // fetchPresetColors) into blankColorsOverride instead.
    // Curated "Garment color" blocks may be scoped to one or more categories
    // via their optional `categories` setting (comma-separated) — e.g. a
    // "Safety Orange" swatch only offered for hats, or a smaller palette for
    // totes. A block with no `categories` set applies to every category.
    function colorAppliesToCategory(c, cat) {
      if (!c.categories) return true;
      if (!cat) return true;
      var list = c.categories.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      return list.indexOf(cat) !== -1;
    }
    function currentColors() {
      if (state.product) return state.product.colors;   // wizard: only the chosen product's own colours
      if (state.blankColorsOverride && state.blankColorsOverride.length) return state.blankColorsOverride;
      var b = currentBlank();
      if (b && b.colors && b.colors.length) return b.colors;
      // In product-page mode, COLORS is that one specific product's own
      // variants — once a real blank is chosen (even one with no detected
      // Color option of its own), it's never a sensible fallback, since it
      // would show swatches belonging to an unrelated product. Only the
      // general multi-category studio falls back to the merchant's curated
      // swatch blocks here.
      if (IS_PRODUCT && b) return [];
      var cat = state.blankCategory || state.category;
      return COLORS.filter(function (c) { return colorAppliesToCategory(c, cat); });
    }
    function currentBlank() {
      if (!state.blank) return null;
      var list = BLANKS[state.blankCategory] || [];
      return list.filter(function (b) { return b.handle === state.blank; })[0] || null;
    }
    function resetColorForGarment() {
      // A product-page embed's ambient COLORS array is that one specific
      // product's own variants — not a sensible fallback once the customer
      // has switched to a *different* blank that happens to have no
      // detected Color option of its own (currentColors() would otherwise
      // silently fall back to it, showing the wrong garment's photo). Use
      // the newly chosen blank's own photo directly in that case instead.
      var b = currentBlank();
      if (IS_PRODUCT && b && (!b.colors || !b.colors.length)) {
        state.colorLabel = 'As shown';
        state.colorImage = b.image || '';
        state.colorBack = b.back || '';
        return;
      }
      var list = currentColors();
      var c = list[0];
      if (!c) return;
      state.color = c.hex || state.color;
      state.colorLabel = c.name || state.colorLabel;
      state.colorImage = c.image || c.photo || '';
      state.colorBack = c.back || '';
    }
    // Swatches: curated "Garment color" blocks may set an explicit swatch
    // photo (c.image) — show that as the round swatch itself. Real catalog
    // blanks instead carry c.photo (the real per-variant product photo used
    // to update the canvas) alongside c.hex — the swatch stays a plain color
    // circle so the picker still reads as color options, not a strip of
    // near-identical white/grey studio photos.
    function buildColors() {
      if (!colorsWrap) return;
      colorsWrap.innerHTML = '';
      currentColors().forEach(function (c) {
        var swatchSrc = c.image || c.photo || '';
        var active = swatchSrc ? (swatchSrc === state.colorImage) : (c.hex === state.color);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'studio__color' + (c.image ? ' studio__color--img' : '') + (active ? ' is-active' : '');
        if (c.image) { b.style.backgroundImage = 'url(' + c.image + ')'; }
        else { b.style.background = c.hex; }
        b.title = c.name;
        b.setAttribute('aria-label', c.name || 'Color');
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
        b.addEventListener('click', function () {
          state.color = c.hex || state.color; state.colorLabel = c.name;
          state.colorImage = c.image || c.photo || ''; state.colorBack = c.back || '';
          colorName.textContent = c.name; buildColors(); renderGarment();
          if (state.product) { renderChosenBlank(); renderOrderProduct(); renderPickerCurrent(); }
        });
        colorsWrap.appendChild(b);
      });
      colorName.textContent = state.colorLabel;
    }
    // Category tabs filter which real products show up in the blank picker
    // (and, via GARMENTS blocks if configured, calibrate the print-area box
    // for that category). IS_PRODUCT pages never call any of this — they
    // keep the original single-product embed.
    var CATEGORY_LABELS = { tee: 'T-Shirts', longsleeve: 'Long Sleeves', hoodie: 'Hoodies', tank: 'Tanks', polo: 'Polos', bag: 'Tote Bags', hat: 'Hats', promo: 'Promotional Products', sweatshirt: 'Sweatshirts', other: 'Other' };
    // Small decorative glyphs for the category pills — purely presentational
    // (aria-hidden), the visible + accessible label is still the text next to it.
    var CATEGORY_ICONS = {
      tee: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/></svg>',
      longsleeve: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 7 7 3h10l5 4-3 4-2-1v11H7V10l-2 1z"/></svg>',
      hoodie: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8 8 4h8l4 4-3 3-2-1v11H7V11l-2 1z"/><path d="M9 4a3 3 0 0 0 6 0"/></svg>',
      tank: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 3 6 6v3l2 1v11h8V10l2-1V6l-2-3q-2 3-4 3t-4-3z"/></svg>',
      polo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.38 3.46 16 2l-2 3-2-3-4 1.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H9v10c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V10h1.77a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/></svg>',
      bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l1 13H5z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
      hat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 13a8 8 0 0 1 16 0"/><path d="M2 13h20l-1.5 3H3.5z"/></svg>',
      promo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/></svg>',
      sweatshirt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8 8 4h8l4 4-3 3-2-1v11H7V11l-2 1z"/></svg>'
    };
    // Used only by entry points elsewhere (product-page "Customize" CTAs, and
    // eventually Catalog/collection links) to send shoppers straight to the
    // right dedicated studio page. NOT used by these tabs — the general
    // studio's own category tabs must keep switching in place (see below).
    // Keep in sync with the routing in sections/main-product.liquid.
    var CATEGORY_ROUTES = {
      tee: '/pages/design-studio-tshirts',
      longsleeve: '/pages/design-studio-tshirts',
      tank: '/pages/design-studio-tshirts',
      polo: '/pages/design-studio-tshirts',
      hoodie: '/pages/design-studio-hoodies',
      bag: '/pages/design-studio-tote-bags',
      hat: '/pages/design-studio-hats',
      promo: '/pages/design-studio-promo',
      sweatshirt: '/pages/design-studio-sweatshirts'
    };
    function categoriesList() {
      if (LOCKED_CATEGORIES.length) return LOCKED_CATEGORIES.slice();
      var seen = {}, list = [];
      GARMENTS.forEach(function (g) {
        var c = g.category || 'tee';
        if (!seen[c]) { seen[c] = true; list.push(c); }
      });
      Object.keys(BLANKS).forEach(function (c) {
        if (BLANKS[c] && BLANKS[c].length && !seen[c]) { seen[c] = true; list.push(c); }
      });
      return list;
    }
    function buildCategories() {
      // Setting state.category must happen even when the tab strip itself
      // isn't in the DOM (locked single-category pages no longer render the
      // "Category" heading/wrapper at all — see design-studio.liquid) — this
      // is the only place state.category gets initialized, so returning
      // early here left it stuck at '' on every locked page.
      var cats = categoriesList();
      if (!state.category || cats.indexOf(state.category) === -1) state.category = cats[0] || '';
      if (!categoriesWrap) return;
      categoriesWrap.innerHTML = '';
      // Locked pages are single-purpose (e.g. a dedicated Tote Bags page) —
      // no tabs to switch between, even when locked to a group of categories
      // (the T-Shirt studio's tee/longsleeve/tank/polo group).
      if (LOCKED_CATEGORIES.length || cats.length < 2) return;
      cats.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        var active = c === state.category;
        b.className = 'studio__category' + (active ? ' is-active' : '');
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
        b.innerHTML = (CATEGORY_ICONS[c] || '') + '<span>' + escapeHtml(CATEGORY_LABELS[c] || c) + '</span>';
        b.addEventListener('click', function () {
          // Switch in place — this is the general multi-category studio,
          // so its own tabs must keep working like a normal browser. The
          // dedicated per-category pages are for entry points elsewhere
          // (Catalog/collections, product-page "Customize" links) — see
          // CATEGORY_ROUTES, used only by those, not by these tabs.
          state.category = c;
          buildCategories();
          renderPrintArea();
          autoSelectBlank();
        });
        categoriesWrap.appendChild(b);
      });
    }

    /* ----- Step 1 of the wizard: live catalog browser -----
       Products are never baked into the page. They are fetched on demand,
       24 at a time, from two lightweight JSON-emitting alternate templates
       (templates/collection.studio.liquid and templates/search.studio.liquid
       — paginated, server-side search) with Shopify's public
       /collections/{handle}/products.json as a fallback. Only products that
       have a photo are ever rendered; there is no placeholder/SVG tile. */
    var PK_PAGE_SIZE = 24;
    var PK_MIN_BATCH = 12;       // keep fetching pages until this many cards were added (or the list ends)
    var PK_HIDDEN_HANDLES = ['custom-order-internal-do-not-purchase'];
    var pk = {
      mode: 'collection', handle: 'all', q: '', page: 0, pages: 1,
      loading: false, token: 0, seen: {}, shown: 0, picking: false, searchTimer: 0,
      sources: ['all'], si: 0, abort: null
    };
    // Locked per-category pages: same picker, pre-scoped to the matching
    // collection(s). Collections are found by TITLE among the store's real
    // collections (no handles hardcoded), so imports/renames don't break it.
    var LOCK_RULES = {
      tee: { cols: [/^t-?shirts?$/i], browse: function (c) { return c !== 'longsleeve' && c !== 'tank'; } },
      longsleeve: { cols: [/^t-?shirts?$/i], browse: function (c) { return c === 'longsleeve'; } },
      tank: { cols: [/^t-?shirts?$/i], browse: function (c) { return c === 'tank'; } },
      polo: { cols: [/polo/i] },
      hoodie: { cols: [/sweatshirt|fleece/i], browse: function (c) { return c === 'hoodie'; } },
      sweatshirt: { cols: [/sweatshirt|fleece/i], browse: function (c) { return c !== 'hoodie'; } },
      hat: { cols: [/^caps?$|hats?|headwear/i] },
      bag: { cols: [/^bags?$|tote/i] },
      promo: { cols: [/accessor|promo/i], noSearchFilter: true }
    };
    var pkScope = null;   // set in pkInit for locked pages: {sources, browse, search}
    var pkEl = {
      root: root.querySelector('[data-picker]'),
      grid: root.querySelector('[data-pk-grid]'),
      status: root.querySelector('[data-pk-status]'),
      more: root.querySelector('[data-pk-more]'),
      empty: root.querySelector('[data-pk-empty]'),
      emptyMsg: root.querySelector('[data-pk-empty-msg]'),
      emptyReset: root.querySelector('[data-pk-empty-reset]'),
      search: root.querySelector('[data-pk-search]'),
      clear: root.querySelector('[data-pk-clear]'),
      cats: root.querySelector('[data-pk-cats]'),
      current: root.querySelector('[data-pk-current]'),
      currentTag: root.querySelector('[data-pk-current-tag]')
    };

    function normUrl(u) {
      if (!u) return '';
      if (typeof u === 'object') u = u.src || u.url || '';
      if (u.indexOf('//') === 0) u = 'https:' + u;
      return u;
    }
    // Shopify CDN resizes on the fly via ?width=
    function sized(u, w) {
      if (!u) return '';
      if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
      return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }
    // Imported titles read "Women's Tank NL6733 - NL6733": drop the duplicated
    // trailing style number (it is shown on its own line instead).
    function cleanTitle(t, sku) {
      t = String(t || '').trim();
      var m = t.match(/^(.*\S)\s+-\s+([A-Za-z0-9][\w\/.\-]*)$/);
      if (m && m[1].indexOf(m[2]) !== -1) t = m[1];
      if (sku && t.length > sku.length + 1 && t.slice(-(sku.length + 1)) === ' ' + sku) t = t.slice(0, -(sku.length + 1));
      return t;
    }
    // Only used to pick a default print rectangle + base-price category.
    function inferCategory(p) {
      var tags = Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || '');
      var hay = ((p.title || '') + ' ' + (p.type || p.product_type || '') + ' ' + tags).toLowerCase();
      if (/\b(jacket|vest|coat|parka|apron|pant|pants|short|shorts|shell)\b/.test(hay)) return 'other';
      if (/\b(cap|caps|hat|hats|beanie|visor|headwear|bucket)\b/.test(hay)) return 'hat';
      if (/\b(bag|bags|tote|backpack|duffel|duffle|cooler|sack)\b/.test(hay)) return 'bag';
      if (/hood(ie|y)/.test(hay)) return 'hoodie';
      if (/sweatshirt|crewneck|crew neck|fleece|pullover/.test(hay)) return 'sweatshirt';
      if (/\bpolos?\b/.test(hay)) return 'polo';
      if (/\btank|sleeveless/.test(hay)) return 'tank';
      if (/long[\s-]*sleeve/.test(hay)) return 'longsleeve';
      if (/\btees?\b|t[\s-]?shirt|tshirt/.test(hay)) return 'tee';
      return 'other';
    }
    // Build the customer's working "blank" from /products/{handle}.js
    function buildProduct(p) {
      var images = (p.images || []).map(normUrl).filter(Boolean);
      if (!images.length && p.featured_image) images = [normUrl(p.featured_image)].filter(Boolean);
      if (!images.length) return null;
      var imgs900 = images.map(function (u) { return sized(u, 900); });
      var colorIdx = -1;
      (p.options || []).forEach(function (opt, i) {
        var n = (typeof opt === 'string' ? opt : ((opt && opt.name) || '')).toLowerCase();
        if (colorIdx === -1 && (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1)) colorIdx = i;
      });
      var sku = '';
      var colors = [];
      var byName = {};
      (p.variants || []).forEach(function (v) {
        if (!sku && v.sku) sku = v.sku;
        if (colorIdx === -1) return;
        var name = v['option' + (colorIdx + 1)];
        if (!name) return;
        var e = byName[name];
        if (!e) { e = byName[name] = { name: name, hex: resolveColorHex(name), photo: '', sku: v.sku || '' }; colors.push(e); }
        if (!e.photo && v.featured_image) e.photo = sized(normUrl(v.featured_image), 900);
        if (!e.sku && v.sku) e.sku = v.sku;
      });
      colors.forEach(function (c) { if (!c.photo) c.photo = imgs900[0]; });
      var handle = p.handle || String(p.url || '').replace(/^.*\/products\//, '').split('?')[0];
      return {
        handle: handle,
        title: cleanTitle(p.title, sku),
        sku: sku,
        url: window.location.origin + '/products/' + handle,
        images: imgs900,
        thumb: sized(images[0], 160),
        colors: colors,
        category: inferCategory(p),
        type: p.type || ''
      };
    }

    function pkSetStatus(msg) { if (pkEl.status) pkEl.status.textContent = msg || ''; }
    function pkSkeletons(n) {
      var out = [];
      for (var i = 0; i < n; i++) {
        var li = document.createElement('li');
        li.className = 'pk__item pk__item--skeleton';
        li.setAttribute('aria-hidden', 'true');
        li.innerHTML = '<span class="pk__card"><span class="pk__img"></span><span class="pk__line"></span><span class="pk__line pk__line--short"></span></span>';
        pkEl.grid.appendChild(li);
        out.push(li);
      }
      return out;
    }
    function pkMarkActive() {
      if (!pkEl.grid) return;
      Array.prototype.forEach.call(pkEl.grid.querySelectorAll('[data-handle]'), function (b) {
        var on = !!state.product && b.getAttribute('data-handle') === state.product.handle;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function pkCard(it, idx) {
      var sku = it.s || '';
      var title = cleanTitle(it.t, sku);
      var li = document.createElement('li');
      li.className = 'pk__item';
      li.style.setProperty('--i', idx % PK_PAGE_SIZE);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pk__card';
      b.setAttribute('data-handle', it.h);
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', 'Choose ' + title + (sku ? ', style ' + sku : ''));
      var wrap = document.createElement('span');
      wrap.className = 'pk__img';
      var img = document.createElement('img');
      img.width = 400; img.height = 400;
      img.alt = '';
      img.decoding = 'async';
      if (idx >= 6 || pk.shown > 0) img.loading = 'lazy';   // first screenful loads eagerly
      img.sizes = '(min-width: 1180px) 220px, (min-width: 900px) 25vw, (min-width: 640px) 33vw, 50vw';
      img.srcset = sized(it.i, 200) + ' 200w, ' + sized(it.i, 400) + ' 400w, ' + sized(it.i, 600) + ' 600w';
      img.addEventListener('load', function () { img.classList.add('is-loaded'); });
      // A photo that fails to load is dropped entirely — never an empty tile.
      img.addEventListener('error', function () {
        if (li.parentNode) li.parentNode.removeChild(li);
        pkCheckDeadEnd();
      });
      img.src = sized(it.i, 400);
      wrap.appendChild(img);
      b.appendChild(wrap);
      var t = document.createElement('span');
      t.className = 'pk__title'; t.textContent = title;
      b.appendChild(t);
      if (sku) {
        var s = document.createElement('span');
        s.className = 'pk__sku'; s.textContent = sku;
        b.appendChild(s);
      }
      b.addEventListener('click', function () { pkSelect(it.h, b); });
      li.appendChild(b);
      if (state.product && state.product.handle === it.h) { b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true'); }
      return li;
    }

    function pkUrl(page) {
      if (pk.mode === 'search') return '/search?view=studio&type=product&q=' + encodeURIComponent(pk.q) + '&page=' + page;
      return '/collections/' + encodeURIComponent(pk.sources[pk.si]) + '?view=studio&page=' + page;
    }
    // Fetch one page -> {items:[{h,t,i,s}], pages}. Aborts when superseded and
    // after 15s; falls back to the stock products.json if the alternate
    // template isn't available.
    function pkFetchPage(page, signal) {
      // (no Accept: application/json header — Shopify would then return its stock JSON instead of the alternate template)
      return fetch(pkUrl(page), { credentials: 'same-origin', signal: signal })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); })
        .catch(function (err) {
          if (pk.mode !== 'collection' || (signal && signal.aborted)) throw err;
          return fetch('/collections/' + encodeURIComponent(pk.sources[pk.si]) + '/products.json?limit=' + PK_PAGE_SIZE + '&page=' + page, { signal: signal })
            .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
            .then(function (j) {
              var list = j.products || [];
              return {
                pages: list.length < PK_PAGE_SIZE ? page : page + 1,
                items: list.filter(function (p) { return p.images && p.images.length; }).map(function (p) {
                  var v = (p.variants || [])[0] || {};
                  return { h: p.handle, t: p.title, i: sized(normUrl(p.images[0]), 400), s: v.sku || '' };
                })
              };
            });
        });
    }
    function pkLooksRelevant(items) {
      var words = pk.q.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
      if (!words.length || !items.length) return true;
      return items.some(function (it) {
        var hay = ((it.t || '') + ' ' + (it.s || '')).toLowerCase();
        return words.some(function (w) { return hay.indexOf(w) !== -1; });
      });
    }
    function pkReset() {
      pk.token++;
      if (pk.abort) { try { pk.abort.abort(); } catch (e) {} pk.abort = null; }
      pk.si = 0;
      pk.page = 0; pk.pages = 1; pk.seen = {}; pk.shown = 0; pk.loading = false;
      pkEl.grid.innerHTML = '';
      pkEl.empty.hidden = true;
      pkEl.more.hidden = true;
    }
    function pkHasMore() {
      return pk.page < pk.pages || (pk.mode === 'collection' && pk.si < pk.sources.length - 1);
    }
    function pkAccept(it) {
      if (!pkScope) return true;
      var cat = inferCategory({ title: it.t || '' });
      if (pk.mode === 'search') return !pkScope.search || pkScope.search(cat);
      return !pkScope.browse || pkScope.browse(cat);
    }
    function pkShowEmpty() {
      pkEl.empty.hidden = false;
      pkEl.emptyMsg.textContent = pk.mode === 'search'
        ? 'No products match “' + pk.q + '”. Try a style number or a shorter word.'
        : 'No products with photos in this category yet. Try another category.';
      pkEl.emptyReset.hidden = !pkEl.chipsPresent || (pk.mode !== 'search' && pk.handle === 'all');
      pkSetStatus('No products found.');
    }
    // If every image on a page failed (or nothing was usable) never leave a
    // dead end: offer "Load more" while pages remain, else the empty state.
    function pkCheckDeadEnd() {
      if (pk.loading || pk.picking) return;
      if (pkEl.grid.querySelector('.pk__item:not(.pk__item--skeleton)')) return;
      if (pkHasMore()) { pkEl.more.hidden = false; pkEl.more.textContent = 'Load more products'; pkSetStatus('Some photos could not load.'); }
      else pkShowEmpty();
    }
    function pkLoad() {
      if (pk.loading || !pkHasMore()) return;
      var token = pk.token;
      pk.loading = true;
      pkEl.root.setAttribute('aria-busy', 'true');
      pkEl.more.hidden = true;
      var firstLoad = pk.shown === 0;
      var skels = pkSkeletons(firstLoad ? 8 : 4);
      pkSetStatus('Loading products…');
      var added = 0;
      function dropSkels() { skels.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); }); }
      function finish() {
        dropSkels();
        pk.loading = false;
        pkEl.root.setAttribute('aria-busy', 'false');
        pkEl.more.hidden = !pkHasMore();
        pkEl.more.textContent = 'Load more products';
        var count = pkEl.grid.querySelectorAll('.pk__item:not(.pk__item--skeleton)').length;
        pk.shown = count;
        if (!count) { pkShowEmpty(); }
        else {
          pkEl.empty.hidden = true;
          pkSetStatus(count + ' product' + (count === 1 ? '' : 's') + ' shown' + (pkHasMore() ? '. More available.' : '.'));
        }
      }
      function fail() {
        if (token !== pk.token) return;
        dropSkels();
        pk.loading = false;
        pkEl.root.setAttribute('aria-busy', 'false');
        pkEl.more.hidden = false;
        pkEl.more.textContent = 'Retry loading products';
        pkSetStatus('We couldn’t load products just now. Check your connection and tap retry.');
      }
      function step() {
        if (pk.mode === 'collection' && pk.page >= pk.pages && pk.si < pk.sources.length - 1) { pk.si++; pk.page = 0; pk.pages = 1; }
        var page = pk.page + 1;
        var ctl = window.AbortController ? new AbortController() : null;
        pk.abort = ctl;
        var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 15000);
        pkFetchPage(page, ctl && ctl.signal).then(function (data) {
          clearTimeout(timer);
          if (token !== pk.token) return;   // a newer search/filter superseded this request
          // This store's search falls back to loosely-related results for
          // gibberish; if nothing on the first page mentions any search word,
          // show the friendly "no results" state instead.
          if (pk.mode === 'search' && page === 1 && !pkLooksRelevant(data.items || [])) data = { items: [], pages: 1 };
          pk.page = page;
          pk.pages = Math.max(1, data.pages || 1);
          var frag = document.createDocumentFragment();
          (data.items || []).forEach(function (it) {
            if (!it || !it.h || !it.i || pk.seen[it.h] || PK_HIDDEN_HANDLES.indexOf(it.h) !== -1) return;
            if (!pkAccept(it)) return;
            pk.seen[it.h] = true;
            frag.appendChild(pkCard(it, added));
            added++;
          });
          if (skels[0] && skels[0].parentNode) skels[0].parentNode.insertBefore(frag, skels[0]); else pkEl.grid.appendChild(frag);
          if (added < PK_MIN_BATCH && pkHasMore() && page < 60) { step(); return; }
          finish();
        }).catch(function () { clearTimeout(timer); fail(); });
      }
      step();
    }
    function pkSetActiveChip(handle) {
      if (!pkEl.cats) return;
      Array.prototype.forEach.call(pkEl.cats.querySelectorAll('[data-collection]'), function (b) {
        var on = handle !== null && b.getAttribute('data-collection') === handle;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var sel = pkEl.cats.querySelector('[data-pk-overflow]');
      if (sel) {
        var inSel = !!handle && Array.prototype.some.call(sel.options, function (o) { return o.value === handle; });
        sel.value = inSel ? handle : '';
        sel.classList.toggle('is-active', inSel);
      }
    }
    function pkBrowse(handle) {
      pk.mode = 'collection'; pk.handle = handle; pk.q = '';
      pk.sources = (handle === '__scope' && pkScope) ? pkScope.sources : [handle];
      pkEl.search.value = ''; pkEl.clear.hidden = true;
      pkSetActiveChip(handle);
      pkReset(); pkLoad();
    }
    function pkRunSearch(q) {
      pk.mode = 'search'; pk.q = q;
      pkSetActiveChip(null);
      pkReset(); pkLoad();
    }
    // Default view: the locked page's scope, or All Products.
    function pkHome() { pkBrowse(pkScope ? '__scope' : 'all'); }
    function pkResolveScope() {
      var rule = null, i;
      var cats = LOCKED_CATEGORIES;
      if (!cats.length) return;
      var cols = [], seenH = {};
      // A group page (e.g. tee+longsleeve+tank+polo) unions each member's collections.
      cats.forEach(function (c) {
        var r = LOCK_RULES[c]; if (!r) return;
        if (!rule) rule = r;
        r.cols.forEach(function (re) {
          Array.prototype.forEach.call(pkEl.cats.querySelectorAll('[data-collection]'), function (chip) {
            var h = chip.getAttribute('data-collection');
            if (!seenH[h] && re.test(chip.textContent.trim())) { seenH[h] = true; cols.push(h); }
          });
        });
      });
      var single = cats.length === 1 ? LOCK_RULES[cats[0]] : null;
      pkScope = {
        sources: cols.length ? cols : ['all'],
        browse: single ? single.browse : null,
        // Search spans the whole store, so keep only products that look like
        // this page's category (promo/unknown categories are not filtered).
        search: (single && single.noSearchFilter) || !cols.length ? null : function (cat) { return cats.indexOf(cat) !== -1; }
      };
    }
    function pkInit() {
      if (!pkEl.root) return;
      pkEl.chipsPresent = !LOCKED_CATEGORIES.length;
      pkResolveScope();
      if (pkScope) {
        pkEl.cats.hidden = true;
        var ttl = root.querySelector('[data-step-panel="blank"] .studio__group-title');
        if (ttl) ttl.textContent = 'Choose your product';
      }
      // More than 50 collections: Liquid only renders the first page, so pull
      // the rest from /collections.json (also page-limited) until none are left.
      var morePages = pkEl.cats.querySelector('[data-pk-more-collections]');
      if (morePages && !pkScope) {
        (function pull(page) {
          fetch('/collections.json?limit=250&page=' + page).then(function (r) { return r.json(); }).then(function (j) {
            var list = j.collections || [];
            list.forEach(function (c) {
              if (c.handle === 'frontpage' || c.handle === 'all' || !c.products_count) return;
              if (pkEl.cats.querySelector('[data-collection="' + c.handle + '"]')) return;
              var b = document.createElement('button');
              b.type = 'button'; b.className = 'pk__chip'; b.setAttribute('data-collection', c.handle); b.setAttribute('aria-pressed', 'false');
              b.textContent = new DOMParser().parseFromString(c.title, 'text/html').documentElement.textContent;
              pkEl.cats.appendChild(b);
            });
            if (list.length >= 250 && page < 10) pull(page + 1);
          }).catch(function () {});
        })(1);
      }
      // Many collections: keep the strip tidy with a "More categories" menu.
      var chips = Array.prototype.slice.call(pkEl.cats.querySelectorAll('[data-collection]'));
      var MAX_CHIPS = 14;
      if (chips.length > MAX_CHIPS) {
        var sel = document.createElement('select');
        sel.className = 'pk__overflow';
        sel.setAttribute('data-pk-overflow', '');
        sel.setAttribute('aria-label', 'More categories');
        sel.innerHTML = '<option value="">More categories…</option>';
        chips.slice(MAX_CHIPS - 2).forEach(function (c) {
          var o = document.createElement('option');
          o.value = c.getAttribute('data-collection');
          o.textContent = c.textContent.trim();
          sel.appendChild(o);
          c.parentNode.removeChild(c);
        });
        sel.addEventListener('change', function () { if (sel.value) pkBrowse(sel.value); });
        pkEl.cats.appendChild(sel);
      }
      pkEl.cats.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-collection]') : null;
        if (!b) return;
        pkBrowse(b.getAttribute('data-collection'));
      });
      pkEl.search.addEventListener('input', function () {
        var q = pkEl.search.value.trim();
        pkEl.clear.hidden = !pkEl.search.value;
        clearTimeout(pk.searchTimer);
        pk.searchTimer = setTimeout(function () {
          if (q.length >= 2) { if (!(pk.mode === 'search' && pk.q === q)) pkRunSearch(q); }
          else if (!q && pk.mode === 'search') pkHome();
        }, 250);
      });
      pkEl.search.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pkEl.search.value) { e.preventDefault(); pkEl.clear.click(); } });
      pkEl.search.form && pkEl.search.form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(pk.searchTimer);
        var q = pkEl.search.value.trim();
        if (q.length >= 2) pkRunSearch(q);
      });
      pkEl.clear.addEventListener('click', function () {
        pkEl.search.value = ''; pkEl.clear.hidden = true;
        clearTimeout(pk.searchTimer);
        if (pk.mode === 'search') pkHome();
        pkEl.search.focus();
      });
      pkEl.emptyReset.addEventListener('click', function () { pkHome(); });
      pkEl.more.addEventListener('click', function () {
        pkEl.more.textContent = 'Load more products';
        pkLoad();
      });
      pkHome();
    }

    // Selecting a card: fetch the full product, build the working blank,
    // then advance to Step 2. Any art/text already placed is kept as-is.
    function pkSelect(handle, btn) {
      if (pk.picking) return;
      pk.picking = true;
      pkEl.root.setAttribute('aria-busy', 'true');
      if (btn) btn.classList.add('is-loading');
      pkSetStatus('Loading product…');
      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (p) {
          var prod = buildProduct(p);
          if (!prod) throw new Error('no photo');
          chooseProduct(prod);
          pkSetStatus('');
        })
        .catch(function () {
          pkSetStatus('Sorry, we couldn’t load that product. Please try another.');
          showToast('Couldn’t load that product — please try another');
        })
        .then(function () {
          pk.picking = false;
          pkEl.root.setAttribute('aria-busy', 'false');
          if (btn) btn.classList.remove('is-loading');
        });
    }
    function chooseProduct(prod) {
      state.product = prod;
      state.blank = prod.handle;
      state.blankLabel = prod.title;
      state.blankCategory = prod.category;
      state.category = prod.category;
      state.blankImage = prod.images[0];
      state.blankColorsOverride = null;
      var c0 = prod.colors[0];
      // Keep the customer's colour if the new product offers the same name
      var keep = null;
      prod.colors.forEach(function (c) { if (state.colorLabel && c.name.toLowerCase() === String(state.colorLabel).toLowerCase()) keep = c; });
      var c = keep || c0;
      if (c) { state.color = c.hex; state.colorLabel = c.name; state.colorImage = c.photo; }
      else { state.colorLabel = 'As shown'; state.colorImage = prod.images[0]; }
      state.colorBack = '';
      state.selected = null;
      textBar.classList.remove('is-open');
      buildColors();
      toggleColorGroup();
      renderChosenBlank();
      renderOrderProduct();
      renderPickerCurrent();
      pkMarkActive();
      buildTabs();
      renderPrintArea();
      renderGarment();
      renderElements();
      updateSummary();
      goToStep('customize');
    }
    function productTagHtml(prod) {
      return '<img src="' + prod.thumb + '" alt="" width="52" height="52">'
        + '<div><strong>' + escapeHtml(prod.title) + '</strong>'
        + '<span>' + escapeHtml(state.colorLabel || '') + (prod.sku ? ' · Style ' + escapeHtml(prod.sku) : '') + '</span></div>';
    }
    function renderOrderProduct() {
      var el = root.querySelector('[data-order-product]');
      if (!el || !state.product) return;
      el.innerHTML = productTagHtml(state.product);
    }
    function renderPickerCurrent() {
      if (!pkEl.current) return;
      pkEl.current.hidden = !state.product;
      if (state.product) pkEl.currentTag.innerHTML = productTagHtml(state.product);
    }

    /* ----- Wizard step navigation (Step 1 Choose Blank / 2 Customize / 3 Submit) -----
       Pure visibility + state.step toggle — nothing in `state` is ever reset
       by moving between steps (see ux.md §3 "never loses their work"). */
    var WIZARD_STEPS = ['blank', 'customize', 'submit'];
    function goToStep(step, opts) {
      if (!IS_WIZARD) return;
      opts = opts || {};
      if (WIZARD_STEPS.indexOf(step) === -1) step = 'blank';
      // Steps 2 and 3 need a chosen product.
      var forced = false;
      if (step !== 'blank' && !state.product) { step = 'blank'; forced = true; }
      state.step = step;
      root.setAttribute('data-step', step);
      var idx = WIZARD_STEPS.indexOf(step);
      if (stepsWrap) {
        Array.prototype.forEach.call(stepsWrap.querySelectorAll('[data-step-item]'), function (li) {
          var liIdx = WIZARD_STEPS.indexOf(li.getAttribute('data-step-item'));
          li.classList.toggle('is-active', liIdx === idx);
          li.classList.toggle('is-done', liIdx < idx);
          if (liIdx === idx) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
        });
      }
      if (stepsFill) stepsFill.style.width = (((idx + 1) / WIZARD_STEPS.length) * 100) + '%';
      if (opts.initial) { try { history.replaceState(null, '', '#' + step); } catch (e) {} }
      else if (forced) { try { history.replaceState(null, '', '#blank'); } catch (e) {} }
      else if (!opts.noPush && window.location.hash !== '#' + step) { try { history.pushState(null, '', '#' + step); } catch (e) {} }
      if (step === 'blank') renderPickerCurrent();
      if (step === 'submit') renderOrderProduct();
      if (opts.initial) return;
      // Move focus to the new step's heading for keyboard/screen-reader users
      // — otherwise focus silently stays on the button that was just hidden.
      var panel = root.querySelector('[data-step-panel="' + step + '"]');
      var heading = panel && panel.querySelector('h1, h2');
      if (heading) {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
      var top = root.getBoundingClientRect().top + window.pageYOffset - 70;
      if (window.pageYOffset > top) window.scrollTo(0, Math.max(0, top));   // instant: no mid-page landing, no scroll animation to fight the cross-fade
    }
    if (IS_WIZARD) {
      window.addEventListener('popstate', function () {
        var h = (window.location.hash || '').replace('#', '');
        if (WIZARD_STEPS.indexOf(h) !== -1) goToStep(h, { noPush: true });
      });
    }

    // The real catalog for the active category (or, on a page locked to a
    // *group* of categories — the T-Shirt studio's tee/longsleeve/tank/polo —
    // every category in that group merged together), pulled automatically by
    // product tag (see the section Liquid) — no manual setup needed. Picking
    // one only ever sets the *blank* being ordered, never the canvas photo,
    // so the calibrated print-area box never drifts.
    function blanksForActiveScope() {
      if (LOCKED_CATEGORIES.length > 1) {
        var merged = [];
        LOCKED_CATEGORIES.forEach(function (c) { merged = merged.concat(BLANKS[c] || []); });
        return merged;
      }
      return BLANKS[state.category] || [];
    }
    function buildBlanks() {
      if (!blanksWrap) return;
      blanksWrap.innerHTML = '';
      var list = blanksForActiveScope();
      if (!list.length) {
        blanksWrap.innerHTML = '<p class="studio__hint">No products found for this category yet — tag a product "' + escapeHtml(CATEGORY_LABELS[state.category] || state.category) + '" in Shopify to have it show up here.</p>';
        return;
      }
      list.forEach(function (bl) {
        var b = document.createElement('button');
        b.type = 'button';
        var active = state.blank === bl.handle;
        b.className = 'studio__blank' + (active ? ' is-active' : '');
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
        b.innerHTML = '<img src="' + bl.image + '" alt="">' + '<span>' + escapeHtml(bl.label) + '</span>';
        b.addEventListener('click', function () { chooseBlank(bl, false); });
        blanksWrap.appendChild(b);
      });
    }
    // Auto-picks the first real product in the active category so the canvas
    // always shows an actual product photo — never a generic placeholder.
    function autoSelectBlank() {
      var list = blanksForActiveScope();
      if (list.length) {
        chooseBlank(list[0], true);
      } else {
        state.blank = null; state.blankLabel = ''; state.blankCategory = state.category; state.blankImage = ''; state.blankColorsOverride = null;
        buildBlanks();
        buildColors();
        toggleColorGroup();
        renderChosenBlank();
        toggleBlanksGroup();
        updateSummary();
        renderGarment();
      }
    }
    // Choosing a blank only ever sets which product is being ordered. Manual
    // picks from the grid (resetColor=false) preserve whatever garment color
    // the customer already had selected; auto-selecting a category's default
    // blank (resetColor=true) starts that blank on its own first color.
    function chooseBlank(bl, resetColor) {
      // On a product-page embed, picking any real blank here means the
      // customer is designing a different product than the one the page
      // loaded with — switch the canvas over to the normal blank-driven
      // photo/print-area logic (see baseImageFor/areaFor) instead of the
      // fixed PRODUCT_IMAGE/PRODUCT_AREAS this page started with.
      var wasUsingProductDefault = usingProductDefault;
      usingProductDefault = false;
      state.blank = bl.handle;
      state.blankLabel = bl.label;
      // bl.category is the product's own real sub-category (tee/longsleeve/
      // tank/polo/etc, embedded by the Liquid tag scan) — use that instead of
      // state.category so pricing/lookup stay correct on a page locked to a
      // *group* of categories, where state.category isn't one specific thing.
      state.blankCategory = bl.category || state.category;
      state.blankImage = bl.image;
      state.blankColorsOverride = null; // clear any fetched preset colors from a previous product
      showBlankPicker = false; // a product is now chosen — collapse the grid back down
      // Always reset color on the very first switch away from the product
      // default, even for a manual grid click (resetColor=false) — the
      // "color" carried over would otherwise be the original product's own
      // fixed photo, which has nothing to do with the newly chosen blank.
      if (resetColor || wasUsingProductDefault) resetColorForGarment();
      buildColors();
      toggleColorGroup();
      renderChosenBlank();
      toggleBlanksGroup();
      updateSummary();
      buildBlanks();
      if (wasUsingProductDefault) renderPrintArea(); // print box logic just changed source
      renderGarment();
    }
    function renderChosenBlank() {
      if (!chosenBlankWrap) return;
      if (state.product) {
        if (chosenBlankGroup) chosenBlankGroup.hidden = false;
        chosenBlankWrap.innerHTML = productTagHtml(state.product);
        return;
      }
      if (chosenBlankGroup) chosenBlankGroup.hidden = !state.blank;
      chosenBlankWrap.innerHTML = (state.blankImage ? '<img src="' + state.blankImage + '" alt="" width="48" height="48">' : '')
        + '<div><strong>' + escapeHtml(state.blankLabel) + '</strong></div>';
    }
    // Only the preset flow (arrived via a product page's "Customize" link)
    // hides the "Choose Your Blank" grid — that customer already chose their
    // product, so don't recommend a different one (the "Change" link still
    // re-opens it if they want to switch). The generic "Start Designing"
    // entry is a browsing flow and must always show the grid of blanks.
    function toggleBlanksGroup() {
      if (!blanksGroup) return;
      blanksGroup.hidden = arrivedViaPreset && !showBlankPicker;
    }
    // Hide the color picker only when the active garment has no colours
    // to offer at all.
    function toggleColorGroup() {
      var grp = root.querySelector('[data-color-group]');
      if (!grp) return;
      grp.style.display = currentColors().length ? '' : 'none';
    }

    /* ----- pricing ----- */
    function totalQty() {
      var t = 0;
      sizesWrap.querySelectorAll('input').forEach(function (i) { t += parseInt(i.value, 10) || 0; });
      return t;
    }
    function decoratedLocations() {
      return LOCATIONS.filter(function (l) { return state.designs[l.id].length > 0; }).length;
    }
    // Multiple methods can be chosen at once (e.g. screen print front + embroidered chest).
    function selectedMethods() {
      return Array.prototype.filter.call(methodChecks, function (c) { return c.checked; })
        .map(function (c) { return c.value; });
    }
    function unitPrice() {
      var base = (PRICES.base && PRICES.base[state.blankCategory || state.category]) || PRICES.default_base || 18;
      var locs = decoratedLocations();
      var deco = (PRICES.decoration_first || 6) + Math.max(0, locs - 1) * (PRICES.decoration_extra || 4);
      // Embroidery costs more per piece than screen print/DTF (stitch count, thread).
      var methods = selectedMethods();
      var methodAdd = methods.indexOf('Embroidery') !== -1 ? (PRICES.embroidery_unit || 4) : 0;
      return base + (locs ? deco + methodAdd : 0);
    }
    // One-time fees that don't scale with quantity: a screen per ink color for
    // screen printing, and a digitization fee for embroidery.
    function oneTimeFees() {
      var methods = selectedMethods();
      var fee = 0;
      if (methods.indexOf('Screen Printing') !== -1) {
        var colors = Math.max(1, parseInt(screenColorsInput.value, 10) || 1);
        fee += colors * (PRICES.screen_setup_per_color || 20);
      }
      if (methods.indexOf('Embroidery') !== -1) {
        fee += PRICES.digitization_fee || 35;
      }
      return fee;
    }
    // The summary panel (qty/price breakdown) was removed from the markup —
    // these all no-op safely if their elements aren't present, since pricing
    // is still calculated for the cart properties/spec even without a UI.
    function updateSummary() {
      var qty = totalQty(), unit = unitPrice(), setup = oneTimeFees();
      var qtyEl = root.querySelector('[data-sum-qty]');
      var locsEl = root.querySelector('[data-sum-locs]');
      var unitEl = root.querySelector('[data-sum-unit]');
      var totalEl = root.querySelector('[data-sum-total]');
      if (qtyEl) qtyEl.textContent = qty;
      if (locsEl) locsEl.textContent = decoratedLocations();
      if (unitEl) unitEl.textContent = money(unit);
      var setupRow = root.querySelector('[data-sum-setup-row]');
      var setupEl = root.querySelector('[data-sum-setup]');
      if (setupRow && setupEl) {
        setupEl.textContent = money(setup);
        setupRow.style.display = setup > 0 ? '' : 'none';
      }
      if (totalEl) totalEl.textContent = money(unit * qty + setup);
      buildTabsDots();
    }
    function buildTabsDots() {
      tabsWrap.querySelectorAll('.studio__tab').forEach(function (b, i) {
        var has = state.designs[LOCATIONS[i].id].length > 0;
        var dot = b.querySelector('.dot');
        if (has && !dot) b.insertAdjacentHTML('beforeend', '<span class="dot"></span>');
        if (!has && dot) dot.remove();
      });
    }

    /* ----- export mockup to JPEG -----
       JPEG at moderate quality keeps the data URL small and predictable —
       PNG on an 800px photographic composite can easily exceed 100KB of
       base64, which risked truncation (and a corrupted, unrenderable image)
       when sliced down for the cart property. If it's still too large after
       compression, we drop the image rather than send a broken one — the
       text spec still reaches the order either way. */
    function safeExport(canvas, cb) {
      try {
        var data = canvas.toDataURL('image/jpeg', 0.72);
        if (data.length > 60000) { cb(null); return; }
        cb(data);
      } catch (e) { cb(null); }  // cross-origin product image tainted the canvas
    }
    function exportMockup(cb) {
      var size = 560;
      var canvas = document.createElement('canvas');
      canvas.width = size; canvas.height = size;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#f4f4f2'; ctx.fillRect(0, 0, size, size);
      var view = PRINT_AREAS[state.location].view;
      var baseSrc = baseImageFor(view);
      function drawElements() {
        var els = state.designs[state.location].slice();
        (function next(i) {
          if (i >= els.length) { safeExport(canvas, cb); return; }
          var el = els[i];
          var px = el.x / 100 * size, py = el.y / 100 * size, pw = el.w / 100 * size;
          if (el.type === 'image') {
            var im = new Image();
            im.onload = function () {
              var ph = pw * (im.height / im.width);
              drawRot(ctx, px + pw / 2, py + ph / 2, el.rot, function () {
                ctx.drawImage(im, -pw / 2, -ph / 2, pw, ph);
              });
              next(i + 1);
            };
            im.onerror = function () { next(i + 1); };
            im.src = el.src;
          } else {
            var fs = el.size / 500 * size * (root.querySelector('[data-stage]').offsetWidth ? (size / root.querySelector('[data-stage]').offsetWidth) : 1);
            ctx.save(); ctx.fillStyle = el.color; ctx.font = '700 ' + fs + 'px ' + el.font; ctx.textBaseline = 'top';
            drawRot(ctx, px, py, el.rot, function () { ctx.fillText(el.text, 0, 0); });
            ctx.restore(); next(i + 1);
          }
        })(0);
      }
      if (!baseSrc) { drawElements(); return; }
      var gImg = new Image();
      gImg.crossOrigin = 'anonymous';
      gImg.onload = function () {
        // contain the product photo in the square
        var r = Math.min(size / gImg.width, size / gImg.height);
        var w = gImg.width * r, h = gImg.height * r;
        ctx.drawImage(gImg, (size - w) / 2, (size - h) / 2, w, h);
        drawElements();
      };
      gImg.onerror = function () { drawElements(); };
      gImg.src = baseSrc;
    }
    function drawRot(ctx, cx, cy, deg, draw) {
      ctx.save(); ctx.translate(cx, cy); ctx.rotate(deg * Math.PI / 180); draw(); ctx.restore();
    }
    /* ----- spec text ----- */
    function buildSpec() {
      var lines = [];
      var sku = currentSku(), link = productLink();
      lines.push('Product: ' + productName() + (sku ? ' (Style ' + sku + ')' : '') + ' — ' + state.colorLabel);
      if (link) lines.push('Product link: ' + link);
      var methods = selectedMethods();
      var methodText = methods.length ? methods.join(' + ') : 'Recommend for me';
      if (methods.indexOf('Screen Printing') !== -1) {
        var colors = Math.max(1, parseInt(screenColorsInput.value, 10) || 1);
        methodText += ' (' + colors + ' ink color' + (colors > 1 ? 's' : '') + ')';
      }
      lines.push('Decoration method(s): ' + methodText);
      var setup = oneTimeFees();
      if (setup > 0) lines.push('One-time setup/digitization fees: ' + money(setup));
      var sizes = [];
      sizesWrap.querySelectorAll('input').forEach(function (i) { if ((parseInt(i.value, 10) || 0) > 0) sizes.push(i.getAttribute('data-size') + ':' + i.value); });
      lines.push('Sizes: ' + (sizes.join(', ') || '(to be confirmed)'));
      LOCATIONS.forEach(function (l) {
        var d = state.designs[l.id];
        if (!d.length) return;
        var parts = d.map(function (e) { return e.type === 'image' ? ('uploaded art') : 'text "' + e.text + '"'; });
        lines.push(l.label + ': ' + parts.join(' + '));
      });
      return lines.join('\n');
    }

    /* ----- actions ----- */
    root.querySelector('[data-action="upload"]').addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () {
      var f = fileInput.files[0]; if (!f) return;
      if (f.type.indexOf('image/') !== 0) { showToast('Preview supports PNG/JPG/SVG. For AI/EPS/PDF, upload at checkout or email us.'); fileInput.value=''; return; }
      var reader = new FileReader();
      reader.onload = function () {
        scaleImage(reader.result, f.type === 'image/svg+xml', function (src) { addImage(src); });
      };
      reader.readAsDataURL(f); fileInput.value = '';
    });
    root.querySelector('[data-action="text"]').addEventListener('click', addText);
    Array.prototype.forEach.call(changeBlankBtns, function (btn) {
      btn.addEventListener('click', function () {
        // Wizard mode: "Change product" returns to the Step 1 catalog browser;
        // anything already placed on the canvas is kept.
        if (IS_WIZARD) { goToStep('blank'); return; }
        showBlankPicker = true;
        buildBlanks();
        toggleBlanksGroup();
      });
    });
    // Back/forward controls for the 3-step wizard — pure visibility toggles,
    // state is never cleared by stepping (see goToStep()).
    Array.prototype.forEach.call(root.querySelectorAll('[data-step-back]'), function (btn) {
      btn.addEventListener('click', function () { goToStep(btn.getAttribute('data-step-back')); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-step-next]'), function (btn) {
      btn.addEventListener('click', function () { goToStep(btn.getAttribute('data-step-next')); });
    });
    root.querySelector('[data-action="clear"]').addEventListener('click', function () {
      state.designs[state.location] = []; state.selected = null; renderElements(); textBar.classList.remove('is-open'); showToast('Cleared this side');
    });
    textInput.addEventListener('input', function () { var el = current(); if (el) { el.text = textInput.value; renderElements(); } });
    fontSelect.addEventListener('change', function () { var el = current(); if (el) { el.font = fontSelect.value; renderElements(); } });
    textColor.addEventListener('input', function () { var el = current(); if (el) { el.color = textColor.value; renderElements(); } });

    stage.addEventListener('pointerdown', function (e) { if (e.target === stage || e.target === garmentImg || e.target === printArea || garmentImg.contains(e.target)) deselect(); });

    sizesWrap.addEventListener('input', updateSummary);

    methodChecks.forEach(function (c) {
      c.addEventListener('change', function () {
        if (screenColorsWrap) screenColorsWrap.hidden = selectedMethods().indexOf('Screen Printing') === -1;
        updateSummary();
      });
    });
    if (screenColorsInput) screenColorsInput.addEventListener('input', updateSummary);

    var quoteBtn = root.querySelector('[data-action="quote"]');
    // A short reference embedded in the order properties so staff can find
    // this submission in Admin. Generated once per session.
    var refId = null;
    function refreshArtworkFilenames() {
      if (!artworkFilenameEl) return;
      var names = [];
      Array.prototype.forEach.call(artworkFileInputs, function (inp) {
        if (inp.files && inp.files[0]) names.push(inp.files[0].name);
      });
      artworkFilenameEl.hidden = !names.length;
      artworkFilenameEl.textContent = names.length ? ('Selected: ' + names.join(', ')) : '';
    }
    Array.prototype.forEach.call(artworkFileInputs, function (inp) {
      inp.addEventListener('change', refreshArtworkFilenames);
    });
    // Removes any hidden fields this handler added on a previous attempt
    // before adding a fresh set — prevents duplicate `id`/`quantity`/
    // `properties[...]` fields from stacking up if the customer submits,
    // the request fails, and they submit again.
    function clearDynamicOrderFields() {
      if (!orderForm) return;
      Array.prototype.slice.call(orderForm.querySelectorAll('[data-dynamic-field]')).forEach(function (n) { n.remove(); });
    }
    function addHiddenOrderField(name, value) {
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = name; inp.value = value;
      inp.setAttribute('data-dynamic-field', '');
      orderForm.appendChild(inp);
    }
    if (orderForm) {
      // Real multipart <form method="post" action="/cart/add"> submission —
      // required for the artwork file field (`properties[Artwork File]`) to
      // actually upload and attach to the resulting Order's line item in
      // Shopify Admin. The AJAX `/cart/add.js` + fetch()/FormData path used
      // for the rest of the site does NOT reliably upload file-type
      // properties; this is Shopify's documented mechanism for file-upload
      // line-item properties. `return_to` sends the browser to /checkout
      // after the add completes, matching the old flow's end point.
      orderForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (totalQty() < MIN_QTY) { showToast('Minimum order is ' + MIN_QTY + ' pieces total — add more sizes/quantity'); return; }

        // No placeholder variant configured — fall back to the old email-only quote form.
        if (!variantId) {
          exportMockup(function (url) {
            try {
              localStorage.setItem('hanger_design', JSON.stringify({ spec: buildSpec(), unit: unitPrice(), qty: totalQty(), total: unitPrice() * totalQty(), mockup: url || '', when: Date.now() }));
            } catch (err) {}
            showToast('Design saved — opening quote form…');
            setTimeout(function () { window.location.href = quoteUrl + '?source=design-studio'; }, 800);
          });
          return;
        }

        if (!refId) refId = 'HU-' + Date.now().toString(36).toUpperCase();
        quoteBtn.disabled = true; quoteBtn.textContent = 'Submitting…';
        exportMockup(function (url) {
          clearDynamicOrderFields();
          addHiddenOrderField('id', variantId);
          addHiddenOrderField('quantity', String(totalQty()));
          addHiddenOrderField('properties[Product]', productName());
          addHiddenOrderField('properties[Color]', state.colorLabel || '');
          if (currentSku()) addHiddenOrderField('properties[Style / SKU]', currentSku());
          if (productLink()) addHiddenOrderField('properties[Product Link]', productLink());
          addHiddenOrderField('properties[Order Ref]', refId);
          addHiddenOrderField('properties[Design spec]', buildSpec());
          if (url) addHiddenOrderField('properties[_Mockup]', url);
          // Native submit — a full page navigation, not fetch — so the
          // browser sends the real multipart body (including the artwork
          // file, if one was chosen) straight to /cart/add, then follows
          // Shopify's redirect to /checkout.
          orderForm.submit();
        });
      });
    }

    /* ----- helpers ----- */
    // Style / SKU of the chosen catalog item (the selected colour's variant SKU
    // when there is one) and a full link to it, so staff know what to order.
    function currentSku() {
      if (state.product) {
        var hit = null;
        state.product.colors.forEach(function (c) { if (c.name === state.colorLabel) hit = c; });
        return (hit && hit.sku) || state.product.sku || '';
      }
      if (IS_PRODUCT && usingProductDefault) return root.getAttribute('data-product-sku') || '';
      return '';
    }
    function productLink() {
      if (state.product) return state.product.url;
      if (IS_PRODUCT && usingProductDefault) return root.getAttribute('data-product-url') || '';
      if (state.blank) return window.location.origin + '/products/' + state.blank;
      return '';
    }
    function productName() {
      if (IS_PRODUCT && usingProductDefault) return root.getAttribute('data-product-title') || 'Custom product';
      return state.blankLabel || 'Custom product';
    }
    var toastTimer;
    function showToast(msg) { toast.textContent = msg; toast.classList.add('is-shown'); clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.classList.remove('is-shown'); }, 2600); }

    /* ----- phone keyboard / viewport -----
       While a text field has focus on a phone, the fixed Back/Continue bar is
       hidden (it would sit on top of the field or float above the keyboard)
       and the field is scrolled to the middle of the visible area. */
    var narrowMq = window.matchMedia ? window.matchMedia('(max-width: 760px)') : { matches: false };
    root.addEventListener('focusin', function (e) {
      var t = e.target;
      if (!narrowMq.matches || !t || !/^(INPUT|SELECT|TEXTAREA)$/.test(t.tagName)) return;
      if (t.type === 'checkbox' || t.type === 'radio' || t.type === 'file') return;
      root.classList.add('is-kb');
      setTimeout(function () { try { t.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) { t.scrollIntoView(); } }, 320);
    });
    root.addEventListener('focusout', function () {
      setTimeout(function () {
        var a = document.activeElement;
        if (!a || !root.contains(a) || !/^(INPUT|SELECT|TEXTAREA)$/.test(a.tagName)) root.classList.remove('is-kb');
      }, 120);
    });
    // Block the browser's own long-press menu / selection on the canvas only.
    stage.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* ----- boot ----- */
    if (!IS_WIZARD) buildCategories();
    buildTabs(); renderPrintArea(); renderElements();
    if (IS_WIZARD) {
      // Land on Step 1 and start loading the catalog. Choosing a product (see
      // chooseProduct()) sets up colours/canvas and advances to Step 2.
      goToStep('blank', { initial: true });
      pkInit();
      var presetParam = new URLSearchParams(window.location.search).get('blank_handle');
      if (presetParam) pkSelect(presetParam, null);
    } else if (IS_PRODUCT) {
      resetColorForGarment();
      buildColors();
      toggleColorGroup();
      updateSummary();
      renderGarment();
      buildBlanks(); // populate the "Design a different product" picker
      toggleBlanksGroup();
    } else if (state.blank) {
      // Arrived preset from a product page — its own image/colors are
      // already known (see readPreset); default to its first color. If this
      // product isn't in the auto-scanned catalog, its real colors get
      // fetched next and swapped in once they arrive.
      resetColorForGarment();
      buildColors();
      toggleColorGroup();
      renderChosenBlank();
      toggleBlanksGroup();
      updateSummary();
      buildBlanks();
      renderGarment();
      if (presetNeedsColorFetch) fetchPresetColors(presetHandle);
    } else {
      // No preset — auto-pick the first real product in the default
      // category so the canvas shows an actual product, not a placeholder.
      autoSelectBlank();
    }
  }

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* Downscale an uploaded image before it enters the canvas. A full-res logo or
     phone photo (3000-5000px) repaints slowly on every drag frame; capping the
     longest edge at ~1400px keeps the preview crisp but makes dragging smooth.
     SVGs are left untouched (vector — no bitmap cost). */
  function scaleImage(dataUrl, isSvg, cb) {
    if (isSvg) { cb(dataUrl); return; }
    var img = new Image();
    img.onload = function () {
      var max = 1400;
      if (img.width <= max && img.height <= max) { cb(dataUrl); return; }
      var r = Math.min(max / img.width, max / img.height);
      var c = document.createElement('canvas');
      c.width = Math.round(img.width * r);
      c.height = Math.round(img.height * r);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      // PNG preserves transparency (logos usually need it)
      try { cb(c.toDataURL('image/png')); } catch (e) { cb(dataUrl); }
    };
    img.onerror = function () { cb(dataUrl); };
    img.src = dataUrl;
  }

  /* rAF-coalesced pointer drag: at most one onMove per frame, latest event wins. */
  function rafDrag(onMove, onEnd) {
    var raf = 0, last = null;
    function flush() { raf = 0; if (last) onMove(last); }
    function pm(ev) { last = ev; if (!raf) raf = requestAnimationFrame(flush); }
    function up() {
      document.removeEventListener('pointermove', pm);
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
      if (raf) cancelAnimationFrame(raf);
      if (last) onMove(last);   // apply final position exactly
      if (onEnd) onEnd();
    }
    document.addEventListener('pointermove', pm);
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
  }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-design-studio]').forEach(init);
  });
})();
